import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Bubble from './Bubble'

const AudioContent = styled.audio`
  width: calc(100% - 48px);
  height: 30px;
`

const AudioMessage = ({ isLeft, payload: {url}, avatar, endOfBlock, createdAt}) => {

  return (
    <Bubble
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
      width='332px'
      timestamp={createdAt}
      stampStyle='text'
    >
      <AudioContent src={url} controls />
    </Bubble>
  )
}
export default AudioMessage

AudioMessage.propTypes = {
  avatar: PropTypes.any,
  isLeft: PropTypes.bool,
  payload: PropTypes.object.isRequired,
  endOfBlock: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date).isRequired
}
